import Swiper from "swiper";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

export default function quemConfia() {
    const root = document.querySelector(".swiper.c-quem-confia-slider__swiper");
    if (!root) return;

    const slider = new Swiper(root, {
        modules: [Pagination],
        slidesPerView: 2,
        spaceBetween: 16,
        breakpoints: {
            768: {
                slidesPerView: 4,
            },
            1024: {
                slidesPerView: 7,
            },
        },
    });

    return slider;
}
